import type { MultiKey } from '../core/MultiKey';
import type {
  PortCostData,
  MarcuraPortCosts,
  MarcuraPortCostParams,
} from './context';
import type { LocationId } from '@seaber/common/core/entries';

export class PortCostMap implements MarcuraPortCosts {
  map: MultiKey<PortCostData, MarcuraPortCostParams>;

  constructor(map: MultiKey<PortCostData, MarcuraPortCostParams>) {
    this.map = map;
  }

  get(locationId: LocationId, assortmentId: number): PortCostData | undefined {
    return this.map.get(locationId, assortmentId);
  }

  set(data: PortCostData): void {
    this.map.set(data, data.location_id, data.assortment_id);
  }
}
